/**
 * useChatResumen — cuántos chats tengo sin leer y de qué tipo, para el aviso de la app (estilo luz de la BlackBerry):
 * el globo de la pestaña Chat cambia de color según lo más importante que hay (rojo: me mencionaron · ámbar: escribió un cliente · cian: el resto),
 * y el mismo número se ve en el ícono de la app instalada y en el título de la pestaña.
 * Se actualiza cada 30 s mientras la app está a la vista, al volver a ella y cuando la pantalla de Chat avisa que algo cambió.
 */
import { useEffect, useState } from "react";
import { api } from "../api/client.js";
import { useAuth } from "../context/AuthContext.jsx";

const TITULO = typeof document !== "undefined" ? document.title : "";

export function useChatResumen() {
  const { miembro } = useAuth();
  const [r, setR] = useState(null);

  useEffect(() => {
    if (!miembro?.id) return;
    let vivo = true;
    const cargar = () => {
      if (document.visibilityState !== "visible") return;
      Promise.all([
        api.request("GET", "/api/chat/conversaciones"),
        api.request("GET", "/api/chat/trabajo").catch(() => ({ conversaciones: [] })),   // las conversaciones de trabajo (comentarios de tarea) también cuentan
      ]).then(([x, t]) => {
        if (!vivo) return;
        const l = (x.conversaciones || []).filter((c) => c.no_leidos > 0 && !c.silenciado);
        const w = (t.conversaciones || []).filter((c) => c.no_leidos > 0);
        setR({ chats: l.length + w.length, menc: l.filter((c) => c.menciones > 0).length + w.filter((c) => c.menciones > 0).length, cliente: l.filter((c) => c.ambito === "cliente").length + w.filter((c) => c.cliente_espera).length });
      }).catch(() => {});
    };
    cargar();
    const id = setInterval(cargar, 30000);
    document.addEventListener("visibilitychange", cargar);
    window.addEventListener("chat-cambio", cargar);
    return () => { vivo = false; clearInterval(id); document.removeEventListener("visibilitychange", cargar); window.removeEventListener("chat-cambio", cargar); };
  }, [miembro?.id]);

  // Número en el ícono de la app instalada y en el título de la pestaña.
  const n = r?.chats ?? 0;
  useEffect(() => {
    try { if (n > 0) navigator.setAppBadge?.(n); else navigator.clearAppBadge?.(); } catch { /* el navegador no lo soporta */ }
    const base = TITULO.replace(/^\(\d+\)\s*/, "");
    document.title = n > 0 ? `(${n}) ${base}` : base;
  }, [n]);

  return r;
}
